/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {message} from 'antd'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class AllFactorsDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allFactors: [],
      Drivers: [],
      fromDate: '',
      toDate: '',
      printInfo: [],
      buttonClicked: false
    }
  }

  onResultFetched(data) {
    this.setState({
      allFactors: data
    })
  }

  changeDropDown(data) {
    this.setState({
      allFactors: data,
      lengthPayment: sessionStorage.getItem('countAll')
    })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    var datePickerFrom = this.state.fromDate
    var datePickerTo = this.state.toDate
    if (datePickerTo == '' && datePickerFrom == '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((datePickerFrom != '' || datePickerFrom == null) && isNaN(datePickerFrom)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((datePickerTo != '' || datePickerTo == null) && isNaN(datePickerTo)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      sessionStorage.setItem(
        'params',
        `planDateMin=${datePickerFrom == '' ? '' : datePickerFrom}&planDateMax=${
          datePickerTo == '' ? '' : datePickerTo
        }`
      )
      http
        .get(
          `${REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER}?export=false&pageSize=10&pageNumber=1&planDateMin=${
            datePickerFrom == '' ? '' : datePickerFrom
          }&planDateMax=${datePickerTo == '' ? '' : datePickerTo}`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              allFactors: response.data.object.result,
              lengthResult: response.data.object.countAll,
              buttonClicked: true,
              toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD')
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            // message.error(response.data.description)
          }
        })
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthResult: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['invoiceIds'] === null) {
              excelReport[i]['allInvoice'] = '-'
            } else {
              excelReport[i]['allInvoice'] = excelReport[i]['invoiceIds'].join()
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  render() {
    let excelColumns = [
      {title: 'نام خریدار', value: 'buyerName'},
      {title: 'نام تحویل گیرنده', value: 'recipientName'},
      {title: 'ادرس', value: 'address'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'تلفن', value: 'phone'},
      {title: 'شیوه ارسال', value: 'deliveryMethodTitle'}
    ]
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let params = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')
    let printCol = ['ردیف', 'نام', 'نام کاربری', 'موبایل', 'فاکتور ها']

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش همه فاکتور های رسانندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'driver.name'}
                title={'نام '}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'username'}
                field={'driver.username'}
                title={'نام کاربری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'driver.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn key={'allInvoice'} field={'allInvoice'} title={'فاکتور ها'} />

              {/*{driver.invoiceIds==null?'.':driver.invoiceIds.map((invoices,index)=>(*/}
              {/*<span>{index!=0?' , ':''}{invoices}</span>*/}
              {/*))}*/}
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection ">
          <table className="printTable printReportTable lanscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست همه ی فاکتور های رساننده ها"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={5}
              rightColSpan={2}
              centerColSpan={1}
              leftColSpan={2}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((driver, index) => (
                <tr key={index}>
                  <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                  <td>{driver.driver.name}</td>
                  <td>{driver.driver.username}</td>
                  <td>{driver.driver.mobile}</td>
                  <td style={{textAlign: 'justify'}}>
                    {driver.invoiceIds == null
                      ? '.'
                      : driver.invoiceIds.map((invoices, index) => (
                          <span>
                            {index != 0 ? ' , ' : ''}
                            {invoices}
                          </span>
                        ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>فاکتور های رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="addPayment"
                  printUrl=""
                  url={REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن بانک"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ  از"
                  toLabel="تاریخ  تا"
                  fromId="from"
                  toId="to"
                  defaulValue={true}
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>نام</td>
                  <td>نام کاربری</td>
                  <td>موبایل</td>
                  <td>فاکتورها</td>
                </tr>
                {this.state.allFactors.map((driver, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                    <td>{driver.driver.name}</td>
                    <td>{driver.driver.username}</td>
                    <td>{driver.driver.mobile}</td>
                    <td style={{textAlign: 'justify'}}>
                      {driver.invoiceIds == null
                        ? '.'
                        : driver.invoiceIds.map((invoices, index) => (
                            <span>
                              {index != 0 ? ' , ' : ''}
                              {invoices}
                            </span>
                          ))}
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthResult}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={params}
                  url={REPORT_RETAIL.REPORT_RETAIL_INVOICE_DRIVER}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default AllFactorsDrivers
